export const MypagePasswordCheckDefaultValues = {
  password: '',
};

export const MypageInfoDefaultValues = {
  name: '',
  loginId: '',
  email: '',
  phoneNum: '',
  registrationStatus: null,
  schoolYear: '',
  studentToCourseList: [],
  courseNameList: [],
};
